<template>
  <div>
    <Modal :title="title" :text="text" />
  </div>
</template>

<script>
import Modal from "../../../../components/tools/Modal";
export default {
  components: {
    Modal,
  },
  data() {
    return {
      title: "Principales Autoridades",
      text:
        "Debe considerar principalmente los más altos niveles jerárquicos, hasta Jefes de División",
    };
  },
};
</script>
